<template>
  <v-container fluid>
    <v-row class="mt-0 mb-2" justify="space-between" no-gutters>
      <v-col cols="12" md="4">
        <v-card class="py-3 px-4 vcard_area">
          <v-row>
            <v-col cols="12" md="7">
              <div class="text-h1 mb-2">Orçamentos</div>
              <div class="text text--thin mb-2">Realizar novo cadastro de orçamento</div>
              <v-btn v-if="!$root.Permissions.revendor()" @click="dialog = true" color="primary" class="mt-1"><v-icon class="mr-1">request_page</v-icon>Novo orçamento</v-btn>
            </v-col>
            <v-col cols="12" md="5" v-if="!$root.Permissions.revendor()">
              <div class="icon_area" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                <v-icon>add</v-icon>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="dados"
      disable-sort
      :server-items-length="total"
      :options.sync="options"
      loading-text="Carregando... Por favor aguarde"
      :loading="carregando"
      class="elevation-1 base_table mt-4"
      :footer-props="{
        itemsPerPageOptions: [5,10,15,20,25,50,100],
        showFirstLastPage: true,
        firstIcon: 'skip_previous',
        lastIcon: 'skip_next',
        prevIcon: 'chevron_left',
        nextIcon: 'chevron_right'
      }"
      :header-props="{
        sortIcon: 'north',
      }"
    >
      <template v-slot:top>
        <v-row no-gutters align="center" justify="space-between">
          <v-row no-gutters>
            <div class="py-2 px-2">
              <v-form @submit.prevent="applyFilter()">
                <v-text-field
                  clearable
                  hide-details=""
                  clear-icon="close"
                  v-model="search"
                  outlined
                  label="Busca"
                  @click:clear="limparBusca()"
                ></v-text-field>
              </v-form>
            </div>
            <div class="py-2 px-2" v-if="$root.Permissions.admin()">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="distribuidorSelecionado"
                :items="distribuidoresLista"
                hide-details=""
                clearable
                clear-icon="close"
                label="Distribuidor"
                append-icon="expand_more"
                outlined
                @change="applyFilter()"
                @click:clear="applyFilter()"
              >
              </v-autocomplete>
            </div>
            <div class="py-2 px-2" v-if="$root.Permissions.admin()">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="integrador"
                :items="integradores"
                hide-details=""
                clearable
                clear-icon="close"
                label="Integrador"
                append-icon="expand_more"
                outlined
                @change="applyFilter()"
                @click:clear="applyFilter()"
              >
              </v-autocomplete>
            </div>
          </v-row>
          <div>
              <v-menu
                bottom
                center
                offset-y
                max-height="400"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    Exportar
                    <v-icon>arrow_drop_down</v-icon>
                  </div>
                </template>
                <v-list>
                  <v-list-item @click="exportXls()">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">receipt_long</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para XLS</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
        </v-row>
      </template>
      <template v-slot:item.cliente="{ item }">
        <span
          class="orcamento-link"
          @click="goToContact(item.cliente.uuid_cli_id)"
        >
          {{ item.cliente.cli_nome }}
        </span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-row no-gutters align="center" justify="center">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="openDialogDetalhes(item)" color="primary" class="mr-2">
                visibility
              </v-icon>
            </template>
            <span>Detalhes</span>
          </v-tooltip>
          <v-tooltip top v-if="!$root.Permissions.revendor()">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="openOrcamento(item)" color="primary" class="mr-2">
                edit
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip top v-if="!$root.Permissions.revendor()">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="openDialogDelete(item)" color="primary" class="ml-2">
                delete
              </v-icon>
            </template>
            <span>Excluir</span>
          </v-tooltip>
        </v-row>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="850px"
    >
      <v-card class="ui-dialog-top pb-0">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{orcamento.uuid_orc_id ? 'Editar' : 'Novo'}} orçamento
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-row  justify="space-between">
          <v-col cols="12" sm="12" md="6" lg="6" xl="6" v-if="loadingSistemaSugerido">
            <v-card color="primary" elevation="2" class="px-2 py-2 text-white">
              <v-skeleton-loader type="text" class="mb-1"></v-skeleton-loader>
              <v-skeleton-loader type="text" class="mb-1"></v-skeleton-loader>
              <v-skeleton-loader type="text" class="mb-1"></v-skeleton-loader>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6" xl="6" v-if="loadingSistemaSugerido">
            <v-card color="primary" elevation="2" class="px-2 py-2 text-white">
              <v-skeleton-loader type="text" class="mb-1"></v-skeleton-loader>
              <v-skeleton-loader type="text" class="mb-1"></v-skeleton-loader>
              <v-skeleton-loader type="text" class="mb-1"></v-skeleton-loader>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6" xl="6" v-if="!loadingSistemaSugerido && sistemaExato">
            <v-card elevation="2" class="px-2 py-2">
              <v-row no-gutters>
                <v-col cols="12">
                  <b>Sistema exato:</b><br>
                </v-col>
                <v-col cols="12" class="d-flex justify-space-between pb-1 pt-1">
                  Módulos:
                  <v-chip small label color="green" class="ml-3 font-weight-bold orcamento_dimensionamento_chip" text-color="white">
                    {{sistemaExato.dim_quantidade_modulos ? sistemaExato.dim_quantidade_modulos : '-'}} de {{sistemaExato.dim_potencia_modulo ? sistemaExato.dim_potencia_modulo + ' Wp' : '-'}}
                  </v-chip>
                </v-col>
                <v-col cols="12" class="d-flex justify-space-between pb-1 pt-1">
                  Potência:
                  <v-chip small label color="orange darken-4" class="ml-3 font-weight-bold orcamento_dimensionamento_chip" text-color="white">
                    {{sistemaExato.dim_potencia ? sistemaExato.dim_potencia + ' kWp' : '-'}}
                  </v-chip>
                </v-col>
                <v-col cols="12" class="d-flex justify-space-between pb-1 pt-1" v-if="sistemaExato.dim_tipo_estrutura">
                  Estrutura:
                  <v-chip small label color="primary" class="ml-3 font-weight-bold orcamento_dimensionamento_chip" text-color="white">
                    {{(tiposEstrutura.filter(item => item.value === sistemaExato.dim_tipo_estrutura))[0].text}}
                  </v-chip>
                </v-col>
                <v-col cols="12" class="d-flex justify-space-between pb-1 pt-1">
                  Geração mensal:
                  <v-chip small label color="red" class="ml-3 font-weight-bold orcamento_dimensionamento_chip" text-color="white">
                    ~{{sistemaExato.dim_energia_gerar ? sistemaExato.dim_energia_gerar + ' kWh' : '-'}}
                  </v-chip>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6" xl="6" v-if="!loadingSistemaSugerido && sistemaSugerido">
            <v-card elevation="2" class="px-2 py-2">
              <v-row no-gutters>
                <v-col cols="12">
                  <b>Sistema sugerido:</b><br>
                </v-col>
                <v-col cols="12" class="d-flex justify-space-between pb-1 pt-1">
                  Módulos:
                  <v-chip small label color="green" class="ml-3 font-weight-bold orcamento_dimensionamento_chip" text-color="white">
                    {{sistemaSugerido.dim_quantidade_modulos ? sistemaSugerido.dim_quantidade_modulos : '-'}} de {{sistemaSugerido.dim_potencia_modulo ? sistemaSugerido.dim_potencia_modulo + ' Wp' : '-'}}
                  </v-chip>
                </v-col>
                <v-col cols="12" class="d-flex justify-space-between pb-1 pt-1">
                  Potência:
                  <v-chip small label color="orange darken-4" class="ml-3 font-weight-bold orcamento_dimensionamento_chip" text-color="white">
                    {{sistemaSugerido.dim_potencia ? sistemaSugerido.dim_potencia + ' kWp' : '-'}}
                  </v-chip>
                </v-col>
                <v-col cols="12" class="d-flex justify-space-between pb-1 pt-1" v-if="sistemaSugerido.dim_tipo_estrutura">
                  Estrutura:
                  <v-chip small label color="primary" class="ml-3 font-weight-bold orcamento_dimensionamento_chip" text-color="white">
                    {{(tiposEstrutura.filter(item => item.value === sistemaSugerido.dim_tipo_estrutura))[0].text}}
                  </v-chip>
                </v-col>
                <v-col cols="12" class="d-flex justify-space-between pb-1 pt-1">
                  Geração mensal:
                  <v-chip small label color="red" class="ml-3 font-weight-bold orcamento_dimensionamento_chip" text-color="white">
                    ~{{sistemaSugerido.dim_energia_gerar ? sistemaSugerido.dim_energia_gerar + ' kWh' : '-'}}
                  </v-chip>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-form ref="formOrcamento">
          <v-tabs
            next-icon="chevron_right"
            prev-icon="chevron_left"
            show-arrows
            class="ui-tabs"
            v-model="tabs">
            <v-tab>
              <v-icon>person</v-icon> Dados do cliente
            </v-tab>
            <v-tab>
              <v-icon>article</v-icon> Dados do orçamento
            </v-tab>
            <v-tab>
              <v-icon>shopping_cart</v-icon> Produtos
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs" class="ui-tabs-inherit mb-2">
            <v-tab-item class="px-1 pb-1">
              <v-card class="px-3">
                <v-row class="mt-0">
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0">
                    <v-autocomplete
                      v-model="orcamento.cliente.cli_tipo"
                      autocomplete="off"
                      :items="tipos"
                      :loading="salvando"
                      :disabled="salvando"
                      :rules="[rules.required]"
                      append-icon="expand_more"
                      label="Tipo*"
                      outlined
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0">
                    <v-combobox
                      v-model="orcamento.cliente.cli_nome"
                      :items="listaClientes"
                      hide-no-data
                      :search-input.sync="searchClient"
                      :loading="loadingCliente"
                      return-object
                      autofocus
                      outlined
                      autocomplete="off"
                      ref="clientesSelect"
                      :rules="[rules.required]"
                      label="Nome completo*"
                      @keyup="buscaClientes()"
                      @change="checarCampos()"
                    ></v-combobox>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
                    <v-text-field-simplemask
                      v-model="orcamento.cliente.cli_telefone"
                      v-bind:label="'Telefone'"
                      :loading="salvando"
                      :disabled="salvando"
                      v-bind:properties="{
                        disabled: salvando,
                        loading: salvando,
                        outlined: true,
                        clearable: true,
                        placeholder: '',
                      }"
                      v-bind:options="{
                        inputMask: '(##) #####-####',
                        outputMask: '(##) #####-####',
                        empty: null,
                        applyAfter: false,
                      }"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
                    <v-text-field-simplemask
                      v-model="orcamento.cliente.cli_celular"
                      v-bind:label="'Celular'"
                      :loading="salvando"
                      :disabled="salvando"
                      v-bind:properties="{
                        disabled: salvando,
                        loading: salvando,
                        outlined: true,
                        clearable: true,
                        placeholder: '',
                      }"
                      v-bind:options="{
                        inputMask: '(##) #####-####',
                        outputMask: '(##) #####-####',
                        empty: null,
                        applyAfter: false,
                      }"
                    />
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item class="px-1 pb-1">
              <v-card class="px-3">
                <v-row class="mt-0">
                  <v-col v-if="$root.Permissions.admin()" cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
                    <v-autocomplete
                      :menu-props="{ offsetY: true}"
                      v-model="orcamento.uuid_dis_id"
                      :items="distribuidores"
                      clearable
                      clear-icon="close"
                      label="Distribuidor"
                      append-icon="expand_more"
                      @change="getIntegrators(orcamento.uuid_dis_id, true)"
                      :loading="salvando"
                      :disabled="salvando"
                      outlined
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col v-if="$root.Permissions.admin()" cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
                    <v-autocomplete
                      :menu-props="{ offsetY: true}"
                      v-model="orcamento.uuid_int_id"
                      :items="integradoresCadastro"
                      clearable
                      clear-icon="close"
                      label="Integrador"
                      append-icon="expand_more"
                      :loading="salvando || loadingIntegradores"
                      :disabled="salvando || loadingIntegradores"
                      outlined
                      :rules="[rules.required]"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" class="pb-0">
                    <div class="text-h3">
                      Endereço
                    </div>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0">
                    <v-text-field-cep
                      v-model="orcamento.orc_cep"
                      label="CEP"
                      @change="searchCep(orcamento.orc_cep)"
                      v-bind:properties="{
                        loading: loadingCep || salvando,
                        disabled: loadingCep || salvando,
                        outlined: true,
                        clearable: true,
                        placeholder: '',
                      }"
                      v-bind:options="{
                        outputMask: '########',
                        empty: null,
                        applyAfter: false,
                      }"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0">
                    <v-autocomplete
                      v-model="orcamento.orc_uf"
                      autocomplete="off"
                      :items="estados"
                      :loading="salvando || loadingEstados || loadingCep"
                      :disabled="salvando || loadingEstados || loadingCep"
                      label="Estado"
                      append-icon="expand_more"
                      outlined
                      @change="filterCidade(orcamento.orc_uf)"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
                    <v-autocomplete
                      autocomplete="off"
                      v-model="orcamento.orc_cidade"
                      :items="cidadesFiltradas"
                      :loading="salvando || loadingCidades || loadingCep"
                      :disabled="salvando || loadingCidades || loadingCep"
                      label="Cidade"
                      append-icon="expand_more"
                      outlined
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
                    <v-text-field
                      v-model="orcamento.orc_bairro"
                      outlined
                      :loading="salvando || loadingCep"
                      :disabled="salvando || loadingCep"
                      label="Bairro"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" class="pb-0 pt-0">
                    <v-text-field
                      v-model="orcamento.orc_rua"
                      outlined
                      :loading="salvando || loadingCep"
                      :disabled="salvando || loadingCep"
                      label="Rua"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pt-0 pb-0">
                    <v-text-field
                      v-model="orcamento.orc_numero"
                      outlined
                      :loading="salvando || loadingCep"
                      :disabled="salvando || loadingCep"
                      label="Número"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="9" lg="9" xl="9" class="pt-0 pb-0">
                    <v-text-field
                      v-model="orcamento.orc_complemento"
                      outlined
                      :loading="salvando || loadingCep"
                      :disabled="salvando || loadingCep"
                      label="Complemento"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" class="pb-0">
                    <div class="text-h3">
                      Conta de energia
                    </div>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0">
                    <v-autocomplete
                      v-model="orcamento.orc_modalidade_tarifaria"
                      autocomplete="off"
                      :items="modalidades"
                      :loading="salvando"
                      :disabled="salvando"
                      :rules="[rules.required]"
                      label="Modalidade tarifária*"
                      append-icon="expand_more"
                      outlined
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0">
                    <v-autocomplete
                      v-model="orcamento.orc_entrada_padrao"
                      autocomplete="off"
                      :items="padroes"
                      :loading="salvando"
                      :disabled="salvando"
                      :rules="[rules.required]"
                      label="Padrão de entrada*"
                      append-icon="expand_more"
                      outlined
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0">
                    <v-text-field-percent
                      label="Consumo mensal (kWh)*"
                      :rules="[rules.required]"
                      v-model="orcamento.orc_consumo_mensal"
                      v-bind:properties="{
                        readonly: false,
                        outlined: true,
                        disabled: salvando,
                        loading: salvando
                      }"
                      v-bind:options="{
                        locale: 'pt-BR',
                        length: 12,
                        precision: 2,
                        empty: null,
                      }"
                      @blur="getSistema()"
                    ></v-text-field-percent>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" class="pb-0">
                    <div class="text-h3">
                      Instalação
                    </div>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0">
                    <v-autocomplete
                      :menu-props="{ offsetY: true}"
                      v-model="orcamento.orc_tipo_instalacao"
                      :items="tiposInstalacao"
                      clearable
                      clear-icon="close"
                      label="Tipos de instalação"
                      append-icon="expand_more"
                      :loading="salvando"
                      :disabled="salvando"
                      outlined
                      @blur="getSistema()"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0">
                    <v-autocomplete
                      :menu-props="{ offsetY: true}"
                      v-model="orcamento.orc_tipo_estrutura"
                      :items="tiposEstrutura"
                      clearable
                      clear-icon="close"
                      label="Tipo da estrutura"
                      append-icon="expand_more"
                      :loading="salvando"
                      :disabled="salvando"
                      outlined
                      @blur="getSistema()"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0">
                    <v-text-field-percent
                      label="Potência (kWp)"
                      v-model="orcamento.orc_potencia"
                      v-bind:properties="{
                        readonly: false,
                        outlined: true,
                        disabled: salvando,
                        loading: salvando,
                      }"
                      v-bind:options="{
                        locale: 'pt-BR',
                        length: 12,
                        precision: 2,
                        empty: null,
                      }"
                      @blur="getSistema()"
                    ></v-text-field-percent>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0">
                    <v-text-field-percent
                      label="Potência do módulo (W)"
                      v-model="orcamento.orc_potencia_modulo"
                      v-bind:properties="{
                        readonly: false,
                        outlined: true,
                        disabled: salvando,
                        loading: salvando,
                      }"
                      v-bind:options="{
                        locale: 'pt-BR',
                        length: 12,
                        precision: 2,
                        empty: null,
                      }"
                      @blur="getSistema()"
                    ></v-text-field-percent>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0">
                    <v-text-field-percent
                      label="Área do módulo (m²)"
                      v-model="orcamento.orc_area_modulo"
                      v-bind:properties="{
                        readonly: false,
                        outlined: true,
                        disabled: salvando,
                        loading: salvando,
                      }"
                      v-bind:options="{
                        locale: 'pt-BR',
                        length: 12,
                        precision: 2,
                        empty: null,
                      }"
                      @blur="getSistema()"
                    ></v-text-field-percent>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0">
                    <v-text-field-percent
                      label="Irradiação média diária (hrs)"
                      v-model="orcamento.orc_irradiacao_diaria"
                      v-bind:properties="{
                        readonly: false,
                        outlined: true,
                        disabled: salvando,
                        loading: salvando,
                      }"
                      v-bind:options="{
                        locale: 'pt-BR',
                        length: 12,
                        precision: 2,
                        empty: null,
                      }"
                      @blur="getSistema()"
                    ></v-text-field-percent>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0">
                    <v-text-field-percent
                      label="Percentual de perda (%)"
                      v-model="orcamento.orc_percentual_perda"
                      v-bind:properties="{
                        readonly: false,
                        outlined: true,
                        disabled: salvando,
                        loading: salvando,
                      }"
                      v-bind:options="{
                        locale: 'pt-BR',
                        length: 12,
                        precision: 2,
                        empty: null,
                      }"
                      @blur="getSistema()"
                    ></v-text-field-percent>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item class="px-1 pb-1">
              <v-card class="px-3 pt-2 pb-2 mb-3" style="min-height: 100px">
                <v-row no-gutters align="center" justify="space-between" class="mt-2">
                  <div class="text-h2">
                    <span v-if="distribuidor.uuid_dis_id && distribuidores.length > 0">
                      <b>
                        {{(distribuidores.filter(item => item.value === distribuidor.uuid_dis_id))[0].text}}
                      </b>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" @click="dialogAlterarDistribuidor = true" color="primary" class="ml-1">
                            edit
                          </v-icon>
                        </template>
                        <span>Alterar distribuidor</span>
                      </v-tooltip>
                    </span>
                  </div>
                  <div>
                    <v-btn
                      color="primary"
                      @click="openDialogDistribuidor()"
                      :loading="salvando"
                      :disabled="salvando"
                    >
                      Adicionar produto
                    </v-btn>
                    <v-btn
                      color="primary"
                      @click="openCloseDialog()"
                      class="ml-2"
                      :loading="salvando"
                      :disabled="salvando"
                    >
                      Adicionar produto sem cadastro
                    </v-btn>
                  </div>
                </v-row>
                <v-row justify="end" class="w-100 pt-2 pb-1">
                  <v-badge
                    v-for="item in categoriasProdutos"
                    :key="item.value"
                    :content="item.quantidade"
                    :value="item.quantidade"
                    overlap
                    color="orange accent-3"
                  >
                    <v-chip  small label :color="item.color" class="ml-3 mb-2" text-color="white">
                      {{ item.text }}
                    </v-chip>
                  </v-badge>
                </v-row>
                <v-data-table
                  :headers="headersProdutos"
                  :items="dadosProdutos"
                  loading-text="Carregando... Por favor aguarde"
                  :loading="carregando"
                  class="elevation-1 base_table mt-4 mb-1"
                  :hide-default-footer="true"
                  :items-per-page="-1"
                  :header-props="{
                    sortIcon: 'north',
                  }"
                >
                  <template v-slot:item.pro_categoria="{ item }">
                    <v-chip small label :color="retornaCategoria(item).color" class="orcamento_chip" text-color="white">
                      {{ retornaCategoria(item).text }}
                    </v-chip>
                  </template>
                  <template v-slot:item.pro_preco_venda="{ item }">
                    {{item.pro_valor_tabela ? $root.Formatter.floatToMoney(item.pro_valor_tabela) : $root.Formatter.floatToMoney(item.pro_preco_venda)}}
                  </template>
                  <template v-slot:item.total="{ item }">
                    {{item.pro_valor_tabela ? $root.Formatter.floatToMoney(item.pro_valor_tabela * item.pro_quantidade) : $root.Formatter.floatToMoney(item.pro_preco_venda  * item.pro_quantidade)}}
                  </template>
                  <template v-slot:item.pro_quantidade="{ item }">
                    <v-row no-gutters align="center" justify="start">
                      <v-icon @click="diminuiQuantidadeProduto(item)">do_not_disturb_on</v-icon>
                      <span class="px-2">{{item.pro_quantidade}}</span>
                      <v-icon @click="aumentaQuantidadeProduto(item)">add_circle</v-icon>
                    </v-row>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-row no-gutters align="center" justify="center">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" @click="confirmaRemoveProduto(item)" color="primary" class="ml-2">
                            delete
                          </v-icon>
                        </template>
                        <span>Remover</span>
                      </v-tooltip>
                    </v-row>
                  </template>
                </v-data-table>
                <p class="text-right pt-4 text-h6">
                  Valor total do orçamento: <span class="text-h5 font-weight-bold">{{$root.Formatter.floatToMoney(totalOrcamento)}}</span>
                </p>
              </v-card>
              <v-dialog v-model="dialogRemoveProduto" max-width="400">
                <v-card class="ui-dialog-top">
                  <v-row align="center" justify="space-between">
                    <v-col cols="10">
                      Remover produto
                    </v-col>
                    <v-col cols="2" class="text-right">
                      <v-icon @click="dialogRemoveProduto = false">close</v-icon>
                    </v-col>
                  </v-row>
                </v-card>
                <v-card class="ui-dialog-content">
                  <div class="mb-5">
                    Tem certeza que deseja remover o produto <b>{{produtoRemover.pro_nome}}</b>?
                  </div>
                  <v-divider class="mb-3"></v-divider>
                  <v-row
                    align="center"
                    justify="space-between"
                    class="px-5 py-5"
                  >
                    <v-btn
                      color="cancel"
                      :loading="salvando"
                      :disabled="salvando"
                      @click="dialogRemoveProduto = false"
                    >
                      Cancelar
                    </v-btn>
                    <v-btn
                      color="success"
                      :loading="salvando"
                      :disabled="salvando"
                      @click="removeProdutoLista()"
                    >
                      Remover
                    </v-btn>
                  </v-row>
                </v-card>
              </v-dialog>
              <v-dialog
                v-model="dialogDistribuidor"
                persistent
                max-width="400px"
              >
                <v-card class="ui-dialog-top">
                  <v-row align="center" justify="space-between">
                    <v-col cols="10">
                      Selecione o distribuidor
                    </v-col>
                    <v-col cols="2" class="text-right">
                      <v-icon @click="closeDialogDistribuidor()">close</v-icon>
                    </v-col>
                  </v-row>
                </v-card>
                <v-card class="ui-dialog-content">
                  <v-form ref="formDistribuidor">
                    <v-autocomplete
                      v-model="distribuidor.uuid_dis_id"
                      autocomplete="off"
                      :items="distribuidores"
                      :rules="[rules.required]"
                      :loading="salvando || loadingDistribuidores"
                      :disabled="salvando || loadingDistribuidores"
                      label="Distribuidor*"
                      append-icon="expand_more"
                      outlined
                    ></v-autocomplete>
                  </v-form>
                  <v-divider></v-divider>
                  <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
                    <v-btn
                      color="cancel"
                      :loading="salvando"
                      :disabled="salvando"
                      @click="closeDialogDistribuidor()"
                    >
                      Cancelar
                    </v-btn>
                    <v-btn
                      color="primary"
                      @click="selecionaDistribuidor()"
                      :loading="salvando || loadingDistribuidores"
                      :disabled="salvando || loadingDistribuidores"
                    >
                      Selecionar
                    </v-btn>
                  </v-row>
                </v-card>
              </v-dialog>
              <v-dialog
                v-model="dialogProdutoSemCadastro"
                persistent
                max-width="1100px"
              >
                <v-card class="ui-dialog-top">
                  <v-row align="center" justify="space-between">
                    <v-col cols="10">
                      Selecionar produtos
                    </v-col>
                    <v-col cols="2" class="text-right">
                      <v-icon @click="closeDialogProdutosSemCadastro()">close</v-icon>
                    </v-col>
                  </v-row>
                </v-card>
                <v-card class="ui-dialog-content">
                  <v-form ref="formProdutos" v-if="produtosCategorias && produtosCategorias.length">
                    <v-tabs
                      next-icon="chevron_right"
                      prev-icon="chevron_left"
                      show-arrows
                      class="ui-tabs ui-tabs-big"
                      v-model="tabsProdutos">
                      <v-tab v-for="categoria in produtosCategorias" :key="categoria.uuid_cat_id">
                        <v-icon class="mr-1">{{categoria.cat_id > 7 ? `mdi-${categoria.cat_icone}` : categoria.cat_icone}}</v-icon> {{categoria.cat_nome}}
                      </v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tabsProdutos" class="ui-tabs-inherit">
                      <!-- KITS -->
                      <v-tab-item class="px-1">
                        <v-card class="px-3 pb-2 mb-3 pt-1">
                          <v-data-table
                            multi-sort
                            class="elevation-1 base_table mt-4"
                            loading-text="Carregando... Por favor aguarde"
                            :loading="carregando"
                            v-model="kitsSelecionados"
                            :headers="headersKitsSelect"
                            :search="searchKits"
                            :items="produtosCategorias[0].produtos"
                            item-key="kit_id"
                            show-select
                            :footer-props="{
                              itemsPerPageIcon: 'check_box_outline_blank',
                              itemsPerPageOptions: [5,10,15,20,25,50,100],
                              firstIcon: 'skip_previous',
                              lastIcon: 'skip_next',
                              prevIcon: 'chevron_left',
                              nextIcon: 'chevron_right'
                            }"
                            :header-props="{
                              sortIcon: 'north',
                            }"
                          >
                            <template v-slot:top>
                              <div class="py-2 px-2 table_search_area">
                                <v-text-field
                                  clearable
                                  hide-details=""
                                  clear-icon="close"
                                  v-model="searchKits"
                                  outlined
                                  label="Busca"
                                ></v-text-field>
                              </div>
                            </template>
                            <template v-slot:header.data-table-select="{ props, on }">
                              <v-simple-checkbox
                                color="primary"
                                v-if="props.indeterminate"
                                off-icon="check_box_outline_blank"
                                on-icon="check_box"
                                indeterminate-icon="indeterminate_check_box"
                                v-ripple
                                v-bind="props"
                                :value="props.indeterminate"
                                v-on="on"
                              ></v-simple-checkbox>
                              <v-simple-checkbox
                                color="primary"
                                v-if="!props.indeterminate"
                                v-ripple
                                off-icon="check_box_outline_blank"
                                indeterminate-icon="indeterminate_check_box"
                                on-icon="check_box"
                                v-bind="props"
                                v-on="on"
                              ></v-simple-checkbox>
                            </template>
                            <template v-slot:item.data-table-select="{ isSelected, select, item }">
                              <v-simple-checkbox
                                :value="isSelected"
                                @input="select($event)"
                                off-icon="check_box_outline_blank"
                                indeterminate-icon="indeterminate_check_box"
                                on-icon="check_box"
                              ></v-simple-checkbox>
                            </template>
                            <template v-slot:item.kit_valor="{ item }">
                              {{ $root.Formatter.floatToMoney(item.kit_valor) }}
                            </template>
                          </v-data-table>
                        </v-card>
                      </v-tab-item>
                      <!-- FIM KITS -->
                      <v-tab-item class="px-1" v-if="indexCatProd > 0" v-for="(produtoCategoria, indexCatProd) in produtosCategorias" :key="produtoCategoria.uuid_cat_id + produtoCategoria.cat_id">
                        <v-card class="px-3 pb-2 mb-3 pt-1">
                          <v-data-table
                            multi-sort
                            class="elevation-1 base_table mt-4"
                            loading-text="Carregando... Por favor aguarde"
                            :loading="carregando"
                            v-model="produtosSelecionados"
                            :headers="headersProdutosSelect"
                            :search="searchProdutos[indexCatProd]"
                            :items="produtoCategoria.produtos"
                            item-key="pro_id"
                            show-select
                            :footer-props="{
                              itemsPerPageIcon: 'check_box_outline_blank',
                              itemsPerPageOptions: [5,10,15,20,25,50,100],
                              firstIcon: 'skip_previous',
                              lastIcon: 'skip_next',
                              prevIcon: 'chevron_left',
                              nextIcon: 'chevron_right'
                            }"
                            :header-props="{
                              sortIcon: 'north',
                            }"
                          >
                            <template v-slot:top>
                              <div class="py-2 px-2 table_search_area">
                                <v-text-field
                                  clearable
                                  hide-details=""
                                  clear-icon="close"
                                  v-model="searchProdutos[indexCatProd]"
                                  outlined
                                  label="Busca"
                                ></v-text-field>
                              </div>
                            </template>
                            <template v-slot:header.data-table-select="{ props, on }">
                              <v-simple-checkbox
                                color="primary"
                                v-if="props.indeterminate"
                                off-icon="check_box_outline_blank"
                                on-icon="check_box"
                                indeterminate-icon="indeterminate_check_box"
                                v-ripple
                                v-bind="props"
                                :value="props.indeterminate"
                                v-on="on"
                              ></v-simple-checkbox>
                              <v-simple-checkbox
                                color="primary"
                                v-if="!props.indeterminate"
                                v-ripple
                                off-icon="check_box_outline_blank"
                                indeterminate-icon="indeterminate_check_box"
                                on-icon="check_box"
                                v-bind="props"
                                v-on="on"
                              ></v-simple-checkbox>
                            </template>
                            <template v-slot:item.data-table-select="{ isSelected, select, item }">
                              <v-simple-checkbox
                                :value="isSelected"
                                @input="select($event)"
                                off-icon="check_box_outline_blank"
                                indeterminate-icon="indeterminate_check_box"
                                on-icon="check_box"
                              ></v-simple-checkbox>
                            </template>
                            <template v-slot:item.pro_preco_venda="{ item }">
                              {{item.pro_valor_tabela ? $root.Formatter.floatToMoney(item.pro_valor_tabela) : $root.Formatter.floatToMoney(item.pro_preco_venda)}}
                            </template>
                          </v-data-table>
                        </v-card>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-form>
                  <v-divider></v-divider>
                  <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
                    <v-btn
                      color="cancel"
                      :loading="salvando"
                      :disabled="salvando"
                      @click="closeDialogProdutosSemCadastro()"
                    >
                      Cancelar
                    </v-btn>
                    <v-btn
                      color="primary"
                      @click="selecionaProdutos()"
                      :loading="salvando"
                      :disabled="salvando"
                    >
                      Selecionar
                    </v-btn>
                  </v-row>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogAlterarDistribuidor" max-width="400">
                <v-card class="ui-dialog-top">
                  <v-row align="center" justify="space-between">
                    <v-col cols="10">
                      Alterar distribuidor
                    </v-col>
                    <v-col cols="2" class="text-right">
                      <v-icon @click="dialogAlterarDistribuidor = false">close</v-icon>
                    </v-col>
                  </v-row>
                </v-card>
                <v-card class="ui-dialog-content">
                  <div class="mb-5">
                    Tem certeza que deseja alterar o distribuidor? <br><br>
                    <b>Esta ação removerá todos os produtos já selecionados</b>
                  </div>
                  <v-divider class="mb-3"></v-divider>
                  <v-row
                    align="center"
                    justify="space-between"
                    class="px-5 py-5"
                  >
                    <v-btn
                      color="cancel"
                      :loading="salvando"
                      :disabled="salvando"
                      @click="dialogAlterarDistribuidor = false"
                    >
                      Cancelar
                    </v-btn>
                    <v-btn
                      color="success"
                      :loading="salvando"
                      :disabled="salvando"
                      @click="confirmaAlterarDistribuidor()"
                    >
                      Alterar
                    </v-btn>
                  </v-row>
                </v-card>
              </v-dialog>
            </v-tab-item>
          </v-tabs-items>
        </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditOrcamento()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogDetalhes"
      persistent
      max-width="1000px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Detalhes do orçamento
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialogDetalhes()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-row class="mb-3 mt-1">
          <v-col cols="12" sm="12" md="12" lg="12" xl="12" v-if="!!orcamentoDetalhes">
            <v-card elevation="2" class="px-3 -y-3">
              <v-row justify="center">
                <v-col cols="12" sm="12" md="3" lg="3" xl="3">
                  <v-card class="px-2 py-2 text-center h-100">
                    <v-icon class="mb-1" color="orange" large>solar_power</v-icon><br>
                    <div class="text-h2">
                      {{ orcamentoDetalhes.dimensionamento.dim_quantidade_modulos }} de {{ orcamentoDetalhes.dimensionamento.dim_potencia_modulo.toString().replace('.', ',') }} W
                    </div>
                    <div class="text mt-1">
                      Painéis necessários
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" xl="3">
                  <v-card class="px-2 py-2 text-center h-100">
                    <v-icon class="mb-1" color="cyan" large>wind_power</v-icon><br>
                    <div class="text-h2">
                      {{ orcamentoDetalhes.dimensionamento.dim_potencia.toString().replace('.', ',') }} kWp
                    </div>
                    <div class="text mt-1">
                      Potência necessária
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" xl="3">
                  <v-card class="px-2 py-2 text-center h-100">
                    <v-icon class="mb-1" color="green" large>battery_charging_full</v-icon><br>
                    <div class="text-h2">
                      {{ orcamentoDetalhes.orc_consumo_mensal.replace('.', ',') }} kWh
                    </div>
                    <div class="text mt-1">
                      Comsumo médio mensal
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" xl="3">
                  <v-card class="px-2 py-2 text-center h-100">
                    <v-icon class="mb-1" color="yellow" large>wb_incandescent</v-icon><br>
                    <div class="text-h2">
                      {{ orcamentoDetalhes.dimensionamento.dim_energia_gerar.replace('.', ',') }} kWp
                    </div>
                    <div class="text mt-1">
                      Geração média mensal
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" xl="3">
                  <v-card class="px-2 py-2 text-center h-100">
                    <v-icon class="mb-1" color="yellow" large>flash_on</v-icon><br>
                    <div class="text-h2">
                      {{ orcamentoDetalhes.orc_potencia ? orcamentoDetalhes.orc_potencia.replace('.', ',') : 0 }} kWp
                    </div>
                    <div class="text mt-1">
                      Potência informada
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" xl="3">
                  <v-card class="px-2 py-2 text-center h-100">
                    <v-icon class="mb-1" color="orange" large>flare</v-icon><br>
                    <div class="text-h2">
                      Estimativa
                    </div>
                    <div class="text mt-1">
                      Geração de energia
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" xl="3">
                  <v-card class="px-2 py-2 text-center h-100">
                    <v-icon class="mb-1" color="green" large>paid</v-icon><br>
                    <div class="text-h2">
                      {{ $root.Formatter.floatToMoney(orcamentoDetalhes.orc_total) }}
                    </div>
                    <div class="text mt-1">
                      Total à vista
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12" xl="12" v-if="!!orcamentoOpcoes">
            <v-card elevation="2" class="px-3 -y-3">
              <v-row no-gutters align="center" justify="space-between">
                <div class="text-h2 mb-3 pt-1">
                  Opções de financiamento
                </div>
                <div>
                <v-menu
                  bottom
                  center
                  offset-y
                  max-height="400"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      Exportar
                      <v-icon>arrow_drop_down</v-icon>
                    </div>
                  </template>
                  <v-list>
                    <v-list-item @click="exportXls('opcoes')">
                      <v-list-item-icon class="mr-1">
                        <v-icon color="primary">receipt_long</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Exportar para XLS</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="exportPdf()">
                      <v-list-item-icon class="mr-1">
                        <v-icon color="primary">picture_as_pdf</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Exportar / Imprimir PDF</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="sendToWhatsapp()" v-if="orcamentoDetalhes.cliente && orcamentoDetalhes.cliente.cli_celular">
                      <v-list-item-icon class="mr-1">
                        <img class="icon-whatsapp" src="@assets/img/whatsapp.png" alt="Whatsapp">
                      </v-list-item-icon>
                      <v-list-item-title>Enviar para WhatsApp</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
              </v-row>
              <v-simple-table class="pb-3">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-center">
                        Qtde de parcelas
                      </th>
                      <th class="text-center">
                        Valor da parcela
                      </th>
                      <th class="text-center">
                        Taxa mensal
                      </th>
                      <th class="text-center">
                        Percentual de entrada
                      </th>
                      <th class="text-center">
                        Valor de entrada
                      </th>
                      <th class="text-center">
                        Valor total a pagar
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(opcao, i) in orcamentoOpcoes" :key="i">
                      <td align="center">{{ opcao.quantidade_parcelas }}</td>
                      <td align="center">{{ opcao.valor_parcela }}</td>
                      <td align="center">{{ opcao.taxa_mensal }}</td>
                      <td align="center">{{ opcao.percentual_entrada }}</td>
                      <td align="center">{{ opcao.entrada }}</td>
                      <td align="center">{{ opcao.total_pagar }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="closeDialogDetalhes()"
          >
            Fechar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Remover Orçamento
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogDelete = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja remover este orçamento?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogDelete = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeOrcamento()"
          >
            Remover
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <produtos-form v-on:cancelar-close="openCloseDialog()" v-on:adiciona-produto="adicionaProdutoLista" :produto_sem_cadastro="true" :abrir_dialog="dialogProduto"></produtos-form>
  </v-container>
</template>

<script>
import Api from '@API'
import axios from 'axios'
import _debounce from 'lodash.debounce'
import ProdutosForm from '@pages/produtos/ProdutosForm.vue'

export default {
  components: {
    ProdutosForm
  },
  computed: {
    abrir_dialog () {
      return this.openCloseDialog()
    }
  },
  data () {
    return {
      produtosCategorias: [],
      searchProdutos: [],
      search: '',
      total: 0,
      tabs: 0,
      carregando: true,
      options: {},
      dialog: false,
      dialogDelete: false,
      salvando: false,
      loadingCep: false,
      loadingEstados: false,
      loadingCidades: false,
      estados: [],
      cidades: [],
      cidadesFiltradas: [],
      rules: {
        required: value => !!value || 'Obrigatório.'
      },
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'orc_id'
        },
        { text: 'Cliente', value: 'cliente' },
        { text: 'Consumo mensal', value: 'orc_consumo_mensal' },
        { text: 'Potência', value: 'orc_potencia' },
        { text: 'Potência do módulo', value: 'orc_potencia_modulo' },
        { text: 'Valor total', value: 'orc_total' },
        { text: 'Usuário', value: 'usuario.usu_nome' },
        { text: 'Integrador', value: 'integrador.int_nome' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 130
        }
      ],
      headersOpcoes: [
        { text: 'Qtde de parcelas', value: 'quantidade_parcelas' },
        { text: 'Valor da parcela', value: 'valor_parcela' },
        { text: 'Taxa mensal', value: 'taxa_mensal' },
        { text: 'Percentual de entrada', value: 'percentual_entrada' },
        { text: 'Valor de entrada', value: 'entrada' },
        { text: 'Valor total a pagar', value: 'total_pagar' }
      ],
      dados: [],
      tabelaExtra: null,
      infoImpressao: null,
      loadingIntegradores: false,
      integradores: [],
      distribuidores: [],
      distribuidorSelecionado: null,
      distribuidorAnterior: null,
      distribuidoresLista: [],
      integradoresCadastro: [],
      integrador: null,
      tiposInstalacao: [
        {
          text: 'Comercial',
          value: 1
        },
        {
          text: 'Industrial',
          value: 2
        },
        {
          text: 'Residencial',
          value: 3
        },
        {
          text: 'Rural',
          value: 4
        },
        {
          text: 'Outros',
          value: 5
        }
      ],
      modalidades: [
        {
          text: 'Grupo B - Convencional',
          value: 1
        },
        {
          text: 'Grupo A - Verde',
          value: 2
        },
        {
          text: 'Grupo A - Azul',
          value: 3
        }
      ],
      padroes: [
        {
          text: 'Monofásico',
          value: 1
        },
        {
          text: 'Bifásico',
          value: 2
        },
        {
          text: 'Trifásico',
          value: 3
        }
      ],
      tiposEstrutura: [],
      tipos: [
        {
          text: 'Pessoa Física',
          value: 1
        },
        {
          text: 'Pessoa Jurídica',
          value: 2
        }
      ],
      dialogDetalhes: false,
      orcamentoOpcoes: null,
      orcamento: {
        orc_tipo: 1,
        orc_cep: '',
        orc_uf: '',
        orc_cidade: '',
        orc_bairro: '',
        orc_rua: '',
        orc_numero: '',
        orc_complemento: '',
        orc_modalidade_tarifaria: 1,
        orc_entrada_padrao: 3,
        orc_consumo_mensal: '',
        orc_tipo_instalacao: null,
        orc_tipo_estrutura: null,
        orc_potencia: null,
        orc_potencia_modulo: null,
        orc_irradiacao_diaria: 5.5,
        orc_area_modulo: null,
        orc_percentual_perda: 20,
        uuid_cli_id: '',
        uuid_int_id: '',
        cliente: {
          cli_tipo: 1,
          cli_nome: '',
          cli_telefone: '',
          cli_celular: ''
        }
      },
      orcamentoDetalhes: null,
      loadingDistribuidores: false,
      dialogDistribuidor: false,
      distribuidor: {
        uuid_dis_id: ''
      },
      dialogAlterarDistribuidor: false,
      dialogProduto: false,
      dialogProdutoSemCadastro: false,
      headersProdutos: [
        { text: 'Categoria', value: 'pro_categoria' },
        { text: 'Nome', value: 'pro_nome' },
        { text: 'Preço de venda', value: 'pro_preco_venda' },
        { text: 'Preço Total', value: 'total' },
        { text: 'Quantidade', value: 'pro_quantidade' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dadosProdutos: [],
      headersProdutosSelect: [
        { text: 'Nome', value: 'pro_nome' },
        { text: 'Descrição', value: 'pro_descricao' },
        { text: 'Marca', value: 'marca.mar_nome' },
        { text: 'Modelo', value: 'modelo.mod_nome' },
        { text: 'Preço de venda', value: 'pro_preco_venda' }
      ],
      produtosSelecionados: [],
      kitsSelecionados: [],
      headersKitsSelect: [
        { text: 'Nome', value: 'kit_nome' },
        { text: 'Descrição', value: 'kit_descricao' },
        { text: 'Preço de venda', value: 'kit_valor' }
      ],
      searchKits: '',
      tabsProdutos: 0,
      dialogRemoveProduto: false,
      produtoRemover: {},
      categoriasProdutos: [],
      loadingCategorias: false,
      totalOrcamento: 0,
      listaClientes: [],
      loadingCliente: false,
      serchField: null,
      searchClient: null,
      loadingSistemaSugerido: false,
      sistemaSugerido: null,
      sistemaExato: null
    }
  },
  watch: {
    options: {
      handler () {
        this.getOrcamentos()
      },
      deep: true
    },
    dadosProdutos () {
      this.totalOrcamento = 0
      this.dadosProdutos.map(produto => {
        let valor = produto.pro_valor_tabela ? produto.pro_valor_tabela : produto.pro_preco_venda
        this.totalOrcamento += produto.pro_quantidade * valor
      })
    },
    searchClient (val) {
      this.serchField = val
    }
  },
  methods: {
    async exportXls (type = null) {
      console.log(this.orcamento)
      this.loadingXls = true
      Api.post('relatorios/exportar', {
        headers: this.someHeader(!type ? this.headers : this.headersOpcoes),
        busca: this.search,
        distribuidor: this.distribuidorSelecionado ? this.distribuidorSelecionado : null,
        integrador: this.integrador ? this.integrador : null,
        orcamento: this.orcamentoDetalhes ? this.orcamentoDetalhes.uuid_orc_id : null,
        type: !type ? 'orcamentos' : 'orcamentos-opcoes'
      })
        .then(res => {
          this.downloadXls(res.data.url)
          this.removeXls(res.data.url)
          this.loadingXls = false
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao fazer o donwload!',
            color: 'error'
          })
        })
    },
    async downloadXls (url) {
      const a = document.createElement('a')
      a.href = url
      a.download = url.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    removeXls (url) {
      let data = {
        url: url
      }
      Api.post('relatorios/remove-s3', data)
    },
    someHeader (headers) {
      let cabecalhos = []
      headers.map(header => {
        if (header.text !== 'ID' && header.text !== 'Ações' && header.text !== 'Usuários' && header.text !== 'Imagem') cabecalhos.push(header)
      })
      return cabecalhos
    },
    ajustaDadosParaPDF () {
      this.infoImpressao = {
        headers: [
          {text: 'Painéis necessários', value: 'paineis'},
          {text: 'Potência', value: 'potencia'},
          {text: 'Geração média mensal', value: 'geracao'},
          {text: 'Total à vista', value: 'total'}
        ],
        dados: [
          {
            paineis: `${this.orcamentoDetalhes.dimensionamento.dim_quantidade_modulos} de ${this.orcamentoDetalhes.dimensionamento.dim_potencia_modulo.toString().replace('.', ',')} W`,
            potencia: `${this.orcamentoDetalhes.orc_potencia ? this.orcamentoDetalhes.orc_potencia.replace('.', ',') : this.orcamentoDetalhes.dimensionamento.dim_potencia.toString().replace('.', ',')} kWp`,
            geracao: `${this.orcamentoDetalhes.dimensionamento.dim_energia_gerar.replace('.', ',')} kWp`,
            total: `${this.$root.Formatter.floatToMoney(this.orcamentoDetalhes.orc_total)}`
          }
        ],
        uuid: this.orcamentoDetalhes.orc_id + this.orcamentoDetalhes.uuid_orc_id
      }
      this.tabelaExtra = {
        titulo: 'Opções de financiamento',
        headers: this.headersOpcoes,
        dados: this.orcamentoOpcoes,
        uuid: this.orcamentoDetalhes.uuid_orc_id + this.orcamentoDetalhes.orc_id
      }
    },
    async exportPdf () {
      await this.ajustaDadosParaPDF()
      this.$root.Export.PDF(this, {
        titulo: `Detalhes do orçamento ${this.orcamentoDetalhes.orc_id}`,
        tabela: this.infoImpressao,
        tabelaExtra: this.tabelaExtra
      })
    },
    buscaClientes: _debounce(function () {
      if (this.serchField.length <= 3) return
      this.getClientes()
    }, 500),
    getClientes () {
      this.loadingCliente = true
      this.listaClientes = []
      Api.get('clientes?busca=' + this.serchField)
        .then(res => {
          res.data.map((data) => {
            if (data && data.cli_nome) {
              this.listaClientes.push({
                text: data.cli_nome,
                value: data.uuid_cli_id,
                cli_tipo: data.cli_tipo,
                cli_celular: data.cli_celular,
                cli_telefone: data.cli_telefone,
                cli_cep: data.cli_cep,
                cli_uf: data.cli_uf,
                cli_cidade: data.cli_cidade,
                cli_rua: data.cli_rua,
                cli_numero: data.cli_numero,
                cli_bairro: data.cli_bairro,
                cli_complemento: data.cli_complemento
              })
            }
          })
          this.loadingCliente = false
          setTimeout(() => {
            this.$refs.clientesSelect.focus()
          }, 100)
        })
        .catch(err => {
          console.log(err)
          this.loadingCliente = false
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar clientes!',
            color: 'error'
          })
        })
    },
    checarCampos () {
      if (this.orcamento.cliente.cli_nome && this.orcamento.cliente.cli_nome.text) {
        this.orcamento.uuid_cli_id = this.orcamento.cliente.cli_nome.value
        this.orcamento.cliente.cli_tipo = this.orcamento.cliente.cli_nome.cli_tipo
        this.orcamento.cliente.cli_telefone = this.orcamento.cliente.cli_nome.cli_telefone
        this.orcamento.cliente.cli_celular = this.orcamento.cliente.cli_nome.cli_celular
        this.orcamento.orc_cep = this.orcamento.cliente.cli_nome.cli_cep
        this.orcamento.orc_uf = this.orcamento.cliente.cli_nome.cli_uf
        this.orcamento.orc_cidade = this.orcamento.cliente.cli_nome.cli_cidade
        this.orcamento.orc_bairro = this.orcamento.cliente.cli_nome.cli_bairro
        this.orcamento.orc_rua = this.orcamento.cliente.cli_nome.cli_rua
        this.orcamento.orc_numero = this.orcamento.cliente.cli_nome.cli_numero
        this.orcamento.orc_complemento = this.orcamento.cliente.cli_nome.cli_complemento
        this.desabilitaTipo = true
        this.desabilitaCelular = true
        if (this.orcamento.cliente.cli_nome.cli_uf) {
          this.filterCidade(this.orcamento.cliente.cli_nome.cli_uf)
        }
        this.orcamento.cliente.cli_nome = this.orcamento.cliente.cli_nome.text
      } else {
        this.desabilitaTipo = false
        this.desabilitaCelular = false
        this.orcamento.uuid_cli_id = ''
      }
      console.log(this.orcamento)
      // console.log(this.search)
      // console.log(this.orcamento.cliente.cli_nome)
    },
    limparBusca () {
      this.search = null
      this.options.page = 1
      this.applyFilter()
    },
    applyFilter () {
      if (this.distribuidorAnterior && this.distribuidorSelecionado !== this.distribuidorAnterior) {
        this.integrador = ''
      }
      this.carregando = true

      let query = Object.assign({},
        this.search ? { busca: this.search } : '',
        this.usuario ? { usuario: this.usuario } : '',
        this.distribuidorSelecionado ? { distribuidor: this.distribuidorSelecionado } : '',
        this.integrador ? { integrador: this.integrador } : '',
        this.cliente ? { cliente: this.cliente } : ''
      )

      this.$router.replace({name: 'Orcamentos', query: query}).catch(() => {})

      this.options.page = 1
      this.distribuidorAnterior = this.distribuidorSelecionado
      this.getIntegrators(this.distribuidorSelecionado)
      this.getOrcamentos()
    },
    async getCategorias () {
      this.loadingCategorias = true
      await Api.get('produtos/categorias')
        .then(res => {
          let info = []
          if (res.data && res.data.length > 0) {
            info.push({
              cat_id: 0,
              text: 'Kits',
              value: 'kits',
              color: 'blue darken-4',
              quantidade: 0
            })
            res.data.map(item => {
              info.push({
                cat_id: item.cat_id,
                text: item.cat_nome,
                value: item.uuid_cat_id,
                color: item.cat_cor,
                quantidade: 0
              })
            })
          }
          this.categoriasProdutos = info
          this.loadingCategorias = false
        })
        .catch(err => {
          this.loadingCategorias = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as categorias!',
            color: 'error'
          })
          console.log(err)
        })
    },
    goToContact (uuid) {
      this.$router.push({ name: 'Contato', params: { uuid } }).catch(() => {})
    },
    async getOrcamentos () {
      this.carregando = true
      this.total = 0

      const { page, itemsPerPage } = this.options
      let pagina = 1
      let itensPagina = 10
      let endpoint = ''

      if (page) pagina = page
      if (itemsPerPage) itensPagina = itemsPerPage
      if (this.search) endpoint += `&busca=${this.search}`
      if (this.distribuidorSelecionado && !this.integrador) endpoint += '&distribuidor=' + this.distribuidorSelecionado
      if (this.integrador) endpoint += '&integrador=' + this.integrador
      if (this.cliente) endpoint += `&cliente=${this.cliente}`
      if (this.usuario) endpoint += '&usuario=' + this.usuario

      await Api.get(`orcamentos?page=${pagina}&per_page=${itensPagina}${endpoint}`)
        .then(res => {
          if (res.data) {
            let info = []
            if (res.data.data.length > 0) {
              res.data.data.map(item => {
                info.push({
                  orc_id: item.orc_id,
                  uuid_orc_id: item.uuid_orc_id,
                  cliente: item.cliente,
                  orc_consumo_mensal: item.orc_consumo_mensal ? `${item.orc_consumo_mensal.replace('.', ',')} kWh` : ' - ',
                  orc_potencia: item.orc_potencia ? `${item.orc_potencia.replace('.', ',')} kWp` : ' - ',
                  orc_potencia_modulo: item.orc_potencia_modulo ? `${item.orc_potencia_modulo.replace('.', ',')} W` : ' - ',
                  orc_total: this.$root.Formatter.floatToMoney(item.orc_total),
                  usuario: item.usuario,
                  integrador: item.integrador
                })
              })
            }
            this.total = res.data.total
            this.dados = info
          }
          this.carregando = false
        })
        .catch(err => {
          console.log(err)
          this.carregando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os orçamentos!',
            color: 'error'
          })
        })
    },
    async getIntegrators (distribuidor = null, cadastro = false) {
      this.loadingIntegradores = true
      let url = 'integradores'

      if (distribuidor) {
        url = `distribuidores/${distribuidor}/integradores`
      }
      await Api.get(url)
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.int_nome,
              'value': int.uuid_int_id
            })
          })
          if (cadastro || (!cadastro && !distribuidor)) {
            this.integradoresCadastro = arrayInt
          }

          if (!cadastro) {
            this.integradores = arrayInt
          }
          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    searchCep (cep = '') {
      if (cep.length === 8) {
        this.loadingCep = true
        axios.get('https://viacep.com.br/ws/' + cep + '/json/')
          .then((response) => {
            if (!response.data.erro) {
              this.orcamento.orc_rua = response.data.logradouro
              this.orcamento.orc_bairro = response.data.bairro
              this.orcamento.orc_complemento = response.data.complemento
              if (response.data.uf) {
                this.orcamento.orc_uf = response.data.uf
                this.orcamento.orc_cidade = response.data.localidade
                this.filterCidade(response.data.uf)
              }
            }
          })
          .catch(err => {
            console.log(err)
            this.$root.SnackControl.open(this, {
              text: 'Erro ao buscar por CEP!',
              color: 'error'
            })
          }).finally(() => {
            this.loadingCep = false
          })
      }
    },
    getEstados () {
      this.loadingEstados = true
      axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome')
        .then((response) => {
          for (let estado = 0; estado < response.data.length; estado++) {
            this.estados.push({
              text: response.data[estado].nome,
              value: response.data[estado].sigla
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar os estados!',
            color: 'error'
          })
        })
      this.loadingEstados = false
    },
    getCidade () {
      this.loadingCidades = true
      axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/municipios')
        .then((response) => {
          for (let cidade = 0; cidade < response.data.length; cidade++) {
            this.cidades.push({
              text: response.data[cidade].nome,
              value: response.data[cidade].nome,
              uf: response.data[cidade].microrregiao.mesorregiao.UF.sigla
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar as cidades!',
            color: 'error'
          })
        })
      this.loadingCidades = false
    },
    async openDialogDetalhes (item) {
      try {
        await this.detalhesOrcamento(item.uuid_orc_id)
        await this.detalhesOpcoes(item.uuid_orc_id)
        this.dialogDetalhes = true
      } catch (error) {
        this.dialogDetalhes = false
      }
    },
    async detalhesOrcamento (uuid) {
      this.orcamentoDetalhes = null

      await Api.get(`orcamentos/${uuid}`)
        .then(res => {
          if (res.data) {
            this.orcamentoDetalhes = res.data
            this.dadosProdutos = this.orcamentoDetalhes.produtos
          }
        })
        .catch(err => {
          this.dialogDetalhes = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os dados do orçamento!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async detalhesOpcoes (uuid) {
      this.orcamentoOpcoes = null

      await Api.get(`orcamentos/${uuid}/simulacao`)
        .then(res => {
          if (res.data) {
            this.orcamentoOpcoes = res.data
            this.orcamentoOpcoes.map(opcao => {
              opcao.quantidade_parcelas = `${opcao.quantidade_parcelas}x`
              opcao.valor_parcela = this.$root.Formatter.floatToMoney(opcao.valor_parcela)
              opcao.taxa_mensal = `${opcao.taxa_mensal.replace('.', ',')}%`
              opcao.percentual_entrada = `${opcao.percentual_entrada.replace('.', ',')}%`
              opcao.entrada = this.$root.Formatter.floatToMoney(opcao.entrada)
              opcao.total_pagar = this.$root.Formatter.floatToMoney(opcao.total_pagar)
            })
          }
        })
        .catch(err => {
          this.dialogDetalhes = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os dados do orçamento!',
            color: 'error'
          })
          console.log(err)
        })
    },
    closeDialogDetalhes () {
      this.dialogDetalhes = false
      this.orcamentoOpcoes = null
      this.orcamentoDetalhes = null
      this.dadosProdutos = []
    },
    openOrcamento (item) {
      this.salvando = true
      this.dialog = true
      Api.get('orcamentos/' + item.uuid_orc_id)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          let dados = JSON.parse(JSON.stringify(response.data))
          if (dados.cli_uf) {
            this.filterCidade(response.data.cli_uf)
          }
          if (dados.integrador) {
            dados.uuid_int_id = dados.integrador.uuid_int_id
          }
          this.data = dados.cli_nascimento
          this.orcamento = dados
          if (this.orcamento.distribuidor) {
            this.distribuidor.uuid_dis_id = this.orcamento.distribuidor.uuid_dis_id
          }
          this.dadosProdutos = this.orcamento.produtos
          this.quantidadePorCategoria()
          this.getSistema()
        })
        .catch((error) => {
          this.salvando = false
          this.dialog = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro ao carregar dados do orçamento!',
            color: 'error'
          })
        })
    },
    filterCidade (estado) {
      this.cidadesFiltradas = this.cidades.filter(city => city.uf === estado)
    },
    openDialogDelete (item) {
      this.orcamento = item
      this.dialogDelete = true
    },
    removeOrcamento () {
      this.salvando = true
      Api.delete(`orcamentos/remove/${this.orcamento.uuid_orc_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.msg
          })
          this.salvando = false
          this.dialogDelete = false
          this.getOrcamentos()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover orçamento!',
            color: 'error'
          })
        })
    },
    closeDialog () {
      this.orcamento = {
        orc_tipo: 1,
        orc_cep: '',
        orc_uf: '',
        orc_cidade: '',
        orc_bairro: '',
        orc_rua: '',
        orc_numero: '',
        orc_complemento: '',
        orc_modalidade_tarifaria: 1,
        orc_entrada_padrao: 1,
        orc_consumo_mensal: '',
        orc_tipo_instalacao: null,
        orc_tipo_estrutura: null,
        orc_potencia: '',
        orc_potencia_modulo: '',
        orc_irradiacao_diaria: 5.5,
        orc_area_modulo: '',
        orc_percentual_perda: 20,
        uuid_cli_id: '',
        uuid_int_id: '',
        cliente: {
          cli_tipo: 1,
          cli_nome: '',
          cli_telefone: '',
          cli_celular: ''
        },
        produtos: []
      }
      if (this.$refs.formOrcamento) {
        this.$refs.formOrcamento.resetValidation()
      }
      this.distribuidor = {
        uuid_dis_id: ''
      }
      this.sistemaExato = null
      this.sistemaSugerido = null
      this.serchField = null
      this.searchClient = null
      this.dadosProdutos = []
      this.resetQuantidadeCategoria()
      this.tabs = 0
      this.dialog = false
    },
    saveEditOrcamento () {
      if (!this.$refs.formOrcamento.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      if (!this.orcamento.orc_consumo_mensal) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, informe a média de consumo mensal do cliente.',
          color: 'warning'
        })
        return
      }
      if (this.dadosProdutos.length === 0) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, selecione os produtos para este orçamento.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'orcamentos/novo'
      let editado = false
      if (this.orcamento.uuid_orc_id) {
        endpoint = 'orcamentos/edita'
        editado = true
      }

      this.orcamento.uuid_dis_id = this.distribuidor.uuid_dis_id
      this.orcamento.produtos = this.dadosProdutos
      console.log(this.orcamento, 'this.orcamentothis.orcamentothis.orcamentothis.orcamento')

      Api.post(endpoint, this.orcamento)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Orçamento atualizado com sucesso!' : 'Orçamento cadastrado com sucesso!',
            color: 'success'
          })
          this.closeDialog()
          this.getOrcamentos()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    openDialogDistribuidor () {
      if (this.$root.Permissions.admin() && !this.orcamento.uuid_int_id) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, para executar essa ação selecione um integrador na etapa anterior.',
          color: 'warning'
        })
        return
      }
      if (this.distribuidor.uuid_dis_id === '') {
        this.getDistributors()
        this.dialogDistribuidor = true
      } else {
        this.selecionaDistribuidor()
      }
    },
    confirmaAlterarDistribuidor () {
      this.distribuidor = {
        uuid_dis_id: ''
      }
      this.dadosProdutos = []
      this.dialogAlterarDistribuidor = false
      this.openDialogDistribuidor()
    },
    async getDistributors () {
      this.loadingDistribuidores = true
      await Api.get('distribuidores/distribuidores-vinculados')
        .then(res => {
          let info = []
          info.push({
            value: 'sem-distribuidor',
            text: 'Não escolher distribuidor'
          })
          res.data.map(item => {
            info.push({
              value: item.uuid_dis_id,
              text: item.dis_nome_fantasia ? item.dis_nome_fantasia : item.dis_nome
            })
          })
          this.distribuidores = info
          info.shift()
          this.distribuidoresLista = info
          this.loadingDistribuidores = false
        })
        .catch(err => {
          this.loadingDistribuidores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os distribuidores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    closeDialogDistribuidor () {
      // this.distribuidor = {
      //   uuid_dis_id: ''
      // }
      this.dialogDistribuidor = false
    },
    async selecionaDistribuidor () {
      if (this.$refs.formDistribuidor) {
        if (!this.$refs.formDistribuidor.validate()) {
          this.$root.SnackControl.open(this, {
            text: 'Por favor, preencha os campos corretamente.',
            color: 'warning'
          })
          return
        }
      }
      this.salvando = true

      let endpoint = `produtos/distribuidor/${this.distribuidor.uuid_dis_id}?show_kits=true`
      if (this.$root.Permissions.admin() && !!this.orcamento.uuid_int_id) {
        endpoint = endpoint + '&integrador=' + this.orcamento.uuid_int_id
      }

      await Api.get(endpoint)
        .then(res => {
          this.dialogDistribuidor = false
          this.dialogProdutoSemCadastro = true
          this.salvando = false
          this.produtosCategorias = res.data
        })
        .catch(err => {
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os produtos!',
            color: 'error'
          })
          console.log(err)
        })
    },
    retornaCategoria (produto) {
      let categoria = this.categoriasProdutos.find(cat => cat.cat_id === produto.pro_categoria)
      if (!categoria && produto.fk_kit_id_kit) {
        categoria = this.categoriasProdutos[0]
      }
      if (!categoria) {
        categoria = {
          cat_id: 1000,
          text: 'Categoria removida',
          value: null,
          color: 'red accent-4'
        }
      }

      return categoria
    },
    quantidadePorCategoria () {
      this.categoriasProdutos.map(categoria => {
        categoria.quantidade = 0
      })

      this.dadosProdutos.map(produto => {
        let categoria = this.categoriasProdutos.find(cat => cat.cat_id === produto.pro_categoria)
        if (!categoria && produto.fk_kit_id_kit) {
          categoria = this.categoriasProdutos[0]
        }
        categoria.quantidade += produto.pro_quantidade
      })
    },
    resetQuantidadeCategoria () {
      this.categoriasProdutos.map(categoria => {
        categoria.quantidade = 0
      })
    },
    selecionaProdutos () {
      let produtosTodos = this.produtosSelecionados
      produtosTodos.map((pro) => {
        if (pro.pro_quantidade === 0) {
          pro.pro_quantidade = 1
        }
      })
      let kitsTodos = this.kitsSelecionados
      kitsTodos.map((kit) => {
        if (kit.pro_quantidade === 0) {
          kit.pro_quantidade = 1
        }
      })
      let novosProdutos = this.dadosProdutos.concat(this.produtosSelecionados)
      novosProdutos = novosProdutos.concat(this.kitsSelecionados)
      this.dadosProdutos = novosProdutos
      this.quantidadePorCategoria()
      this.closeDialogProdutosSemCadastro()
    },
    closeDialogProdutosSemCadastro () {
      this.produtosSelecionados = []
      this.kitsSelecionados = []
      this.dialogProdutoSemCadastro = false
      this.tabsProdutos = -1
    },
    aumentaQuantidadeProduto (item) {
      let produtosTodos = []
      produtosTodos = this.dadosProdutos
      produtosTodos.filter((pro) => {
        if (pro === item) {
          pro.pro_quantidade = pro.pro_quantidade + 1
        }
      })
      this.dadosProdutos = JSON.parse(JSON.stringify(produtosTodos))
      this.quantidadePorCategoria()
    },
    diminuiQuantidadeProduto (item) {
      let produtosTodos = []
      produtosTodos = this.dadosProdutos
      produtosTodos.filter((pro) => {
        if (pro === item) {
          pro.pro_quantidade > 1 ? (pro.pro_quantidade = pro.pro_quantidade - 1) : pro.pro_quantidade = 1
        }
      })
      this.dadosProdutos = JSON.parse(JSON.stringify(produtosTodos))
      this.quantidadePorCategoria()
    },
    confirmaRemoveProduto (item) {
      this.produtoRemover = item
      this.dialogRemoveProduto = true
    },
    removeProdutoLista () {
      let produtosAutalizados = this.dadosProdutos.filter((pro) => pro.pro_nome !== this.produtoRemover.pro_nome)
      this.produtoRemover = {}
      this.dialogRemoveProduto = false
      this.dadosProdutos = produtosAutalizados
    },
    adicionaProdutoLista (item) {
      item.pro_quantidade = 1
      item.pro_id = null
      this.dadosProdutos.push(item)
      this.quantidadePorCategoria()
    },
    openCloseDialog () {
      this.dialogProduto = !this.dialogProduto
      return this.dialogProduto
    },
    async getSistema () {
      if (!this.orcamento.orc_consumo_mensal && !this.orcamento.orc_potencia && !this.orcamento.orc_potencia_modulo &&
        !this.orcamento.orc_area_modulo && !this.orcamento.orc_irradiacao_diaria && !this.orcamento.orc_percentual_perda &&
        !this.orcamento.orc_tipo_estrutura) return false

      this.getSistemaSugestao()
      this.getSistemaExato()
    },
    async getSistemaSugestao () {
      this.loadingSistemaSugerido = true
      let data = {
        consumo_medio: this.orcamento.orc_consumo_mensal,
        potencia_desejada: this.orcamento.orc_potencia,
        potencia_modulo_desejada: this.orcamento.orc_potencia_modulo,
        area_modulo: this.orcamento.orc_area_modulo,
        rsi: this.orcamento.orc_irradiacao_diaria,
        perda: this.orcamento.orc_percentual_perda,
        tipo_estrutura: this.orcamento.orc_tipo_estrutura
      }
      await Api.post('dimensionamento/sugerido', data)
        .then(res => {
          let info = null
          if (res.data) {
            info = res.data
          }
          this.sistemaSugerido = info
          console.log(this.sistemaSugerido, 'this.sistemaSugerido')
          this.loadingSistemaSugerido = false
        })
        .catch(err => {
          console.log(err)
          this.loadingSistemaSugerido = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os dados do sistema sugerido!',
            color: 'error'
          })
        })
    },
    async getSistemaExato () {
      this.loadingSistemaSugerido = true
      let data = {
        consumo_medio: this.orcamento.orc_consumo_mensal,
        potencia_desejada: this.orcamento.orc_potencia,
        potencia_modulo_desejada: this.orcamento.orc_potencia_modulo,
        area_modulo: this.orcamento.orc_area_modulo,
        rsi: this.orcamento.orc_irradiacao_diaria,
        perda: this.orcamento.orc_percentual_perda,
        tipo_estrutura: this.orcamento.orc_tipo_estrutura
      }
      await Api.post('dimensionamento/exato', data)
        .then(res => {
          let info = null
          if (res.data) {
            info = res.data
          }
          this.sistemaExato = info
          this.loadingSistemaSugerido = false
        })
        .catch(err => {
          console.log(err)
          this.loadingSistemaSugerido = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os dados do sistema sugerido!',
            color: 'error'
          })
        })
    },
    async getTiposEstrutura () {
      this.loading = true
      await Api.get('tipos-estruturas')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                text: item.tie_nome,
                value: item.tie_id
              })
            })
            this.tiposEstrutura = info
          } else {
            this.tiposEstrutura = []
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os tipos de estruturas!',
            color: 'error'
          })
          console.log(err)
        })
    },
    removeHeader () {
      if (!this.$root.Permissions.admin()) {
        delete this.headers[7]
      }
    },
    loadFunctions () {
      this.removeHeader()
      this.getCategorias()
      this.getCidade()
      this.getEstados()
      this.getTiposEstrutura()
      this.getIntegrators(this.distribuidorSelecionado)
      this.getDistributors()
    },
    loadContent () {
      let filters = this.$route.query
      if (filters.busca) this.search = filters.busca
      if (filters.usuario) this.usuario = filters.usuario
      if (filters.distribuidor) this.distribuidorSelecionado = filters.distribuidor
      if (filters.integrador) this.integrador = filters.integrador
      if (filters.cliente) this.cliente = filters.cliente

      this.loadFunctions()
    },
    createWhatsappMessage () {
      let clientName = this.orcamentoDetalhes.cliente.cli_nome.split(' ')[0]
      let message = `
Olá ${clientName}! Como vai?

Aqui está o orçamento que você solicitou, se tiver alguma dúvida, é só me chamar.

*Detalhes do orçamento*

Painéis necessários: ${this.orcamentoDetalhes.dimensionamento.dim_quantidade_modulos} de ${this.orcamentoDetalhes.dimensionamento.dim_potencia_modulo.toString().replace('.', ',')} W
Potência: ${this.orcamentoDetalhes.orc_potencia ? this.orcamentoDetalhes.orc_potencia.replace('.', ',') : this.orcamentoDetalhes.dimensionamento.dim_potencia.toString().replace('.', ',')} kWp
Geração média mensal: ${this.orcamentoDetalhes.dimensionamento.dim_energia_gerar.replace('.', ',')} kWp
Total à vista: ${this.$root.Formatter.floatToMoney(this.orcamentoDetalhes.orc_total)}

`
      if (this.orcamentoOpcoes.length > 0) {
        message += '*Opções de financiamento*'
        this.orcamentoOpcoes.map(opcao => {
          message += `

Qtde de parcelas: ${opcao.quantidade_parcelas}
Taxa mensal: ${opcao.valor_parcela}
Percentual de entrada: ${opcao.taxa_mensal}
Valor da parcela: ${opcao.percentual_entrada}
Valor de entrada: ${opcao.entrada}
Valor total a pagar: ${opcao.total_pagar}
`
        })
      }

      return window.encodeURIComponent(message)
    },
    sendToWhatsapp () {
      let apiLink = `https://api.whatsapp.com/send/`
      let clientWhatsapp = this.orcamentoDetalhes.cliente.cli_celular.replaceAll('-', '')
        .replaceAll('(', '')
        .replaceAll(')', '')
      let message = this.createWhatsappMessage()

      apiLink += `?phone=+55${clientWhatsapp}&type=phone_number&app_absent=1&text=${message}`
      window.open(apiLink, '_blank')
    }
  },
  created () {
    this.loadContent()
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.orcamento {
  &-link {
    cursor: pointer;
    transition: 0.3s ease;
    &:hover {
      color: $primary;
      transition: 0.3s ease;
    }
  }
}
.orcamento_chip {
  width: 120px;
  justify-content: center;
}
.orcamento_dimensionamento_chip {
  width: 125px;
  justify-content: center;
}
.icon-whatsapp {
  width: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Orcamentos.vue